import React from 'react'
import { observer } from 'mobx-react-lite'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'

import { H3 } from '@mxenabled/mxui'

import { Loader, useCategoryStore, useGlobalStore } from '../../../../common'
import { MiniWidgetProps } from '../../../../core'

import { useAccountUiStore } from '../../../hooks/useUiStore'

interface AccountDetailsChartProps extends MiniWidgetProps {
  ChartComponent?: React.ComponentType
  header?: string
}

const AccountDetailsChart: React.FC<AccountDetailsChartProps> = ({
  sx,
  ChartComponent,
  header,
}) => {
  const { loadMonthlyCategoryTotals } = useCategoryStore()
  const { isInitialized } = useGlobalStore()
  const { selectedAccount } = useAccountUiStore()

  const [isWidgetInitialized, setIsWidgetInitialized] = React.useState(false)

  React.useEffect(() => {
    if (isInitialized) {
      loadMonthlyCategoryTotals([selectedAccount]).finally(() => {
        setIsWidgetInitialized(true)
      })
    }
  }, [isInitialized, selectedAccount])

  if (!isInitialized || !isWidgetInitialized) {
    return <Loader />
  }

  return (
    <Card
      sx={{
        '& .MuiCardContent-root:last-child': {
          pb: 0,
        },
        ...sx,
      }}
    >
      <CardHeader sx={{ pb: 0 }} title={<H3 sx={{ pb: 4 }}>{header}</H3>} />

      <CardContent sx={{ p: 0 }}>{ChartComponent ? <ChartComponent /> : null}</CardContent>
    </Card>
  )
}

export default observer(AccountDetailsChart)
